export default __webpack_public_path__ + "static/media/rtl_online_education.10668d6d.png";